import { deepValue } from '@corratech/pylot-utils'
import {
    ConfigurableProductOptions,
    ProductInterface
} from '@pylot-data/pylotschema'

export const getConfigurableVariant = (item: ProductInterface) => {
    const options = deepValue(item, ['configurable_options'], [])
    const optionLabels = []
    options.map((option: ConfigurableProductOptions) => {
        const label = deepValue(option, ['value_label'])
        if (label) {
            optionLabels.push(label)
        }
    })
    if (optionLabels.length === 0) {
        optionLabels.push(deepValue(item, ['product', 'name']))
    }
    return optionLabels.join(' - ')
}
